import React from 'react';
import styled, {keyframes} from 'styled-components';
import ImageCreateWho from '../../img/create_who.png';
import ImageCreateWhat from '../../img/create_what.png';
import ImageCreateWhere from '../../img/create_location.png';
import ImageCreateEntity from '../../img/create_entity.png';
import ImageCreateSummary from '../../img/create_summary.png';

class GuideCard extends React.Component {

    constructor(props) {
        super(props);

        const anim_fade_in = keyframes`
            from {
                opacity: 0;
            }
            to {
                opacity: 0.8;
            }
        `;

        this.container = styled.div `
            animation: ${anim_fade_in} 0.5s;
            padding: 40px;
            color: ${props => props.theme.colors.blue[0]};
            @media (max-width: 900px) {
                .information_text{
                    width: 100% !important;
                }
                .information_image{
                    display: none !important;
                }
            }
            h1{
                font-size: 32px;
                font-weight: 100;
                margin-bottom: 8px;
            }
            h2{
                font-size: 14px;
                font-weight: 400;
                margin-bottom: 8px;
                opacity: 0;
            }
            h3{
                font-size: 18px;
                line-height: 24px;
                opacity: 0.7;
            }
            .information_text, .information_image{
                display: inline-block;
                vertical-align: top;
            }
            .information_text{
                width: 65%;
                padding-right: 40px;
                padding-top: ${props => props.withForm ? '0px' : '50px'};
            }
            .information_image{
                width: 35%;
                animation: ${anim_fade_in} 0.5s 0.3s both;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
                height: 400px;
                height: 55vh;
            }
        `;

    }

    getImage() {
        switch (this.props.image) {
            case 'entities':
                return ImageCreateEntity;
            case 'who':
                return ImageCreateWho;
            case 'what':
                return ImageCreateWhat;
            case 'summary':
                return ImageCreateSummary;
            case 'where':
                return ImageCreateWhere;
            default:
                return 'no';
        }
    }

    render() {
        return (
            <this.container withForm={this.props.withForm}>
                <div className="information_text">
                    <h1>
                        {this.props.title}
                    </h1>
                    <h2>
                        {this.props.subtitle}
                    </h2>
                    <h3>
                        {this.props.bread}
                    </h3>
                    {this.props.children}
                </div>
                <div className="information_image" style={{backgroundImage: 'url('+this.getImage()+')'}}>
                </div>

            </this.container>
        );
    }
}

export default GuideCard;



// WEBPACK FOOTER //
// ./src/components/base/GuideCard.jsx